"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importStar(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const RadioButtonIcon = props => {
    const { icon, iconSize, iconLabelPosition, text } = props;
    const iconStyles = {
        width: `${iconSize}px`,
        height: `${iconSize}px`,
        fontSize: `${iconSize}px`,
        lineHeight: `${iconSize}px`,
    };
    return ((0, jsx_runtime_1.jsxs)("span", Object.assign({ className: `radio-icon label-${iconLabelPosition}` }, { children: [(0, jsx_runtime_1.jsx)("span", { className: `rioglyph ${icon}`, style: iconStyles }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'radio-label' }, { children: text }))] })));
};
const RadioButton = props => {
    const { checked, children, className, custom, defaultChecked, disabled, icon, iconLabelPosition, iconSize, inline, inputRef, label, name, onChange, onClick, right, tabIndex, value } = props, remainingProps = tslib_1.__rest(props, ["checked", "children", "className", "custom", "defaultChecked", "disabled", "icon", "iconLabelPosition", "iconSize", "inline", "inputRef", "label", "name", "onChange", "onClick", "right", "tabIndex", "value"]);
    const labelRef = (0, react_1.useRef)();
    const handleToggleKeyDown = event => {
        switch (event.key) {
            case ' ':
                // toggle on space
                toggle(event);
                break;
            case 'Enter':
                // open on enter
                toggle(event);
                break;
            default:
                break;
        }
    };
    const toggle = event => {
        event.preventDefault();
        if (disabled) {
            return;
        }
        // Controlled case - uses "onChange()" instead of "onClick()" callback
        if (checked !== null && checked !== undefined) {
            onChange(event);
            return;
        }
        // Uncontrolled case - set the input checked or unchecked
        labelRef.current.firstChild.checked = !labelRef.current.firstChild.checked;
        onClick(event);
    };
    const text = label || children;
    const labelClassnames = (0, classnames_1.default)('radio', inline && 'radio-inline', className);
    const inputClassnames = (0, classnames_1.default)(right && 'icon-right', className);
    const renderCustomIcon = !!icon;
    const renderCustomContent = custom && children;
    const renderDefault = !icon && !custom;
    return ((0, jsx_runtime_1.jsxs)("label", Object.assign({}, remainingProps, { className: labelClassnames, tabIndex: tabIndex, onKeyDown: handleToggleKeyDown, ref: labelRef }, { children: [(0, jsx_runtime_1.jsx)("input", { type: 'radio', defaultChecked: defaultChecked, checked: checked, disabled: disabled, className: inputClassnames, ref: inputRef, onClick: onClick, onChange: onChange, name: name, value: value }), renderCustomIcon && ((0, jsx_runtime_1.jsx)(RadioButtonIcon, { icon: icon, iconSize: iconSize, iconLabelPosition: iconLabelPosition, text: text })), renderDefault && ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'radio-text' }, { children: (0, jsx_runtime_1.jsx)("span", { children: text }) }))), renderCustomContent && children] })));
};
RadioButton.ICON_LABEL_VERTICAL = 'vertical';
RadioButton.ICON_LABEL_HORIZONTAL = 'horizontal';
RadioButton.defaultProps = {
    inline: false,
    disabled: false,
    right: false,
    custom: false,
    tabIndex: 0,
    icon: '',
    iconSize: 16,
    iconLabelPosition: RadioButton.ICON_LABEL_VERTICAL,
    onClick: () => { },
};
RadioButton.propTypes = {
    label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    icon: prop_types_1.default.string,
    iconSize: prop_types_1.default.number,
    iconLabelPosition: prop_types_1.default.oneOf([RadioButton.ICON_LABEL_VERTICAL, RadioButton.ICON_LABEL_HORIZONTAL]),
    onClick: prop_types_1.default.func,
    onChange: prop_types_1.default.func,
    defaultChecked: prop_types_1.default.bool,
    checked: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    inline: prop_types_1.default.bool,
    right: prop_types_1.default.bool,
    custom: prop_types_1.default.bool,
    inputRef: prop_types_1.default.func,
    tabIndex: prop_types_1.default.number,
};
exports.default = RadioButton;
